import { useEffect } from "react";
import { AUTH_TOKEN_REFRESHED_EVENT } from "../../../../http";

export const useRecarregaAoRenovarToken = (callback) => {
    useEffect(() => {
        window.addEventListener(AUTH_TOKEN_REFRESHED_EVENT, callback)
        return () => {
            window.removeEventListener(AUTH_TOKEN_REFRESHED_EVENT, callback)
        }
    }, [callback])
}
